// extracted by extract-css-chunks-webpack-plugin
module.exports = {"aligned":"gOO42U","grid":"_2qISMK","centered-section-spacing":"_3me80O","grid-odd":"_2uX1Yb","pressLogoDesktop":"_2XchiV","pressLogoMobile":"mU041B"};